import {
  Button,
  ButtonGroup,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { FaPen, FaPlus } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
import { updateCategory } from '../../../stores/slices/fourBoxesTemplates/fourBoxesTemplatesActions';
import CustomEditor from '../../Settings/Organisations/CustomEditor';
import AddGoalTemplate from './AddGoalTemplate';

const CategoryTemplate = ({ category, templateId }) => {
  const [goalTooltip, setGoalTooltip] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const schema = yup
    .object({
      goalCategory: yup.string().required('Category is required'),
    })
    .required();
  const dispatch = useDispatch();
  const toast = useToast();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSaveCategory = async data => {
    await dispatch(
      updateCategory({
        templateId,
        goalCategoryId: category.id,
        title: data.goalCategory,
        tooltip: goalTooltip,
      })
    );
    onClose();
    toast({
      description: 'Goal category has been updated',
      colorScheme: 'primary',
      status: 'success',
      duration: 3000,
      isClosable: true,
      position: 'bottom-right',
      variant: 'primary',
    });
  };
  return (
    <React.Fragment>
      <HStack
        direction={'row'}
        justifyContent={'center'}
        alignItems={'center'}
        position="relative"
        w={'full'}
      >
        <Text
          textAlign={{ base: 'left', lg: 'center' }}
          fontWeight={'bold'}
          fontSize={'sm'}
          w="full"
        >
          {category.title !== ''
            ? category.title
            : '[Please enter category title]'}
        </Text>
        <ButtonGroup spacing="1" alignItems={'center'} color="primary">
          <IconButton
            aria-label="Edit"
            icon={<FaPen />}
            variant={'outline'}
            size="sm"
            color={'primary'}
            onClick={onOpen}
          />
          <AddGoalTemplate category={category} templateId={templateId} />
        </ButtonGroup>
      </HStack>
      <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} size={'2xl'}>
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={handleSubmit(onSaveCategory)}>
            <ModalHeader>Edit Category</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl
                id="goalCategory"
                isInvalid={errors.goalCategory}
                mb={'4'}
              >
                <FormLabel>Category Name</FormLabel>
                <Input
                  defaultValue={category.title}
                  id="goalCategory"
                  {...register('goalCategory')}
                />
                <FormErrorMessage>
                  {errors.goalCategory && errors.goalCategory.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl id="tooltip">
                <FormLabel>Tooltip</FormLabel>
                <CustomEditor
                  onChange={setGoalTooltip}
                  val={category.tool_tip || ''}
                  height='300px'
                />
              </FormControl>
            </ModalBody>

            <ModalFooter>
              <Button mr={3} type="submit" isLoading={isSubmitting}>
                Save
              </Button>
              <Button
                onClick={onClose}
                variant="outline"
                disabled={isSubmitting}
              >
                Cancel
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </React.Fragment>
  );
};

export default CategoryTemplate;
